module.exports = "/img/_/_/_/assets/images/creeper/book/uncommon//empty.jpg?e5c68971264789f58905356f6dc721bc";